import { Body1, Button, Title3, makeStyles, tokens } from "@fluentui/react-components";
import { CheckmarkCircle48Regular } from "@fluentui/react-icons";
import { replace } from "../../lib/nav";
import { Shell } from "../../components/Shell";

const useStyles = makeStyles({
  box: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    gap: tokens.spacingVerticalM,
    paddingTop: tokens.spacingVerticalXXXL,
  },
  icon: { fontSize: "56px", color: tokens.colorPaletteGreenForeground1 },
});

export function Inviata({ id }: { id: number }) {
  const s = useStyles();
  return (
    <Shell
      title="Richiesta inviata"
      footer={
        <>
          <Button size="large" style={{ flexGrow: 1 }} onClick={() => replace(`/r/${id}`)}>
            Vedi richiesta
          </Button>
          <Button appearance="primary" size="large" style={{ flexGrow: 1 }} onClick={() => replace("/")}>
            Fatto
          </Button>
        </>
      }
    >
      <div className={s.box}>
        <CheckmarkCircle48Regular className={s.icon} />
        <Title3>Richiesta #{id} inviata</Title3>
        <Body1>I gestori degli acquisti la prenderanno in carico. Puoi seguirne lo stato da "Le tue richieste".</Body1>
      </div>
    </Shell>
  );
}
